<div #firstParent class="canvas h-100">
    <div class="canvas-container h-100" #canvasContainer>
        <canvas #canvas></canvas>
    </div>

    <timeline #timeline class="pe-none" (result)="onTimeline($event)"></timeline>

    @if (userDocument) {
        <div class="document-layout">
            <div class="d-flex justify-content-center align-items-center">
                <button mat-fab (click)="onGoBacktoGlobal()">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <h2 mat-list-item class="text-color-primary mb-0 ms-2">
                    {{userDocument.customerName}}
                    <span matListItemLine class="text-color-primary">{{userDocument.logReferenceId}}
                        {{ userDocument.dateTimeReferenceId | customDate }}</span>
                </h2>
            </div>
        </div>
    }
    <div class="graph-button-layout">
        <button mat-fab aria-label="Graph Button" matTooltip="Show Graph" matTooltipPosition="above" (click)="showGraph()">
            <mat-icon>insert_chart</mat-icon>
        </button>
        <mat-slide-toggle class="ms-2" (change)="heatMapToggle($event)">
            <span class="mb-1 text-color-primary">Show Heat Map</span>
        </mat-slide-toggle>
    </div>
    
    
    <div class="d-flex global-info pe-none">
        <div class="w-100 h-100 position-relative">
            @if (!userDocument) {
                @if (currentHeaderValues.length) {
                    <global-metrics class="flex-grow-1" [metrics]="currentHeaderValues"></global-metrics>
                }@else{
                    <h1 class="text-color-primary text-center flex-grow-1">No Metrics Found for this Period or metric type.</h1>
                }
            }
            <global-metrics class="flex-grow-1" [metrics]="currentSimulationHeaderValues"></global-metrics>

            

            <div class="search-input" [ngClass]="{'show-input':showSearch}">
                @if (!showSearch) {
                    <mat-icon class="search-arrow-icon pe-auto" (click)="onToggleSearch()">arrow_drop_down</mat-icon>
                }@else{
                    <mat-icon class="search-arrow-icon pe-auto" (click)="onToggleSearch()">arrow_drop_up</mat-icon>
                }
        
                <div class="search-layout-container d-flex justify-content-center align-items-center pe-auto mt-1">
                    <div class="search-input-layout">
                        <div class="d-flex justify-content-between align-items-center">
                            <h3>Individual Process Search</h3>
                            <button mat-flat-button (click)="getAffectedDocuments()">
                                <mat-icon>warning</mat-icon>
                                Alert Documents {{alertDocuments}}
                            </button>
                        </div>
                        <div class="d-flex flex-row">
                            <mat-form-field appearance="fill" class="flex-grow-1 me-2">
                                <input matInput [formControl]="searchBox" placeholder="Document ID">
                            </mat-form-field>
                            <button mat-fab (click)="onSearchDocuments()">
                                @if(!isSearchingDocuments){
                                <mat-icon>search</mat-icon>
                                }@else{
                                <mat-progress-spinner class="small-spinner bright-spinner"
                                    mode="indeterminate"></mat-progress-spinner>
                                }
                            </button>
                        </div>
                        @if(!isSearchingDocuments){
                        <mat-action-list class="mb-2 documents-list">
                            @for (document of currentDocuments; track $index) {
                            <button mat-list-item (click)="onSelectDocument(document, document.dateTimeReferenceIdEnd, true)">
                                <span matListItemTitle class="text-color-primary">{{document.customerName}}</span>
                                <span matListItemLine class="text-color-primary">{{document.logReferenceId}}
                                    {{document.dateTimeReferenceId | customDate}}</span>
                            </button>
                            }
                        </mat-action-list>
                        }@else{
                        <div class="d-flex justify-content-center align-items-center">
                            <mat-progress-spinner class="small-spinner custom-spinner"
                                mode="indeterminate"></mat-progress-spinner>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="metric-type-menu pe-none">
        <div class="p-2 metric-type-select d-flex flex-column">
            <mat-form-field class="pe-auto">
                <!-- <mat-label>Select Metric Type</mat-label> -->
                <mat-select [value]="currentMetricType" (selectionChange)="onChangeMetric($event)">
                    @for (metricType of metricsTypes; track metricType.metric_uuid) {
                        <mat-option [value]="metricType">{{metricType.metric}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if(currentMetricType){
                <mat-form-field class="pe-auto">
                    <!-- <mat-label>Select Measure Unit</mat-label> -->
                    <mat-select [value]="currentMeasureUnit" (selectionChange)="onChangeMeasureUnit($event)">
                        @for (metricUnit of currentMetricType.measures; track metricUnit.attribute) {
                            <mat-option [value]="metricUnit">{{metricUnit.unit}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @if(currentMeasureUnit){
                    @if(currentMeasureUnit.symbol == "time"){
                        <mat-form-field class="pe-auto">
                            <!-- <mat-label>Select Time Unit</mat-label> -->
                            <mat-select [value]="currentTimeUnit" (selectionChange)="onChangeTimeUnit($event)">
                                @for (value of timeValues; track value.name) {
                                    <mat-option [value]="value.enum">{{value.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                }
            }
        </div>
    </div>
</div>

<data-view-actions [mainComponent]="appComponent" [dataViewer]="this" [currentTabType]="TabType.METRICS"></data-view-actions>
<center-canvas [centerAction]="fitBoxesWithCamera"></center-canvas>
@if (isLoading) {
    <div class="h-100 d-flex justify-content-center align-items-center loading">
        <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner>
    </div>
}
